<app-header></app-header>
<div class="breadcrumb">
  <div class="container">
    <div class="row">
    </div>
  </div>
</div>
<div class="addSummary">
  <div class="container">
    <div class="row">
      <div class="col-sm-12">
        <div class="">
          <h2>Professional summary</h2>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-6">
        <div class="tinyMCE">
          <editor [init]="utilService.editorConfig" [(ngModel)]="resume.professional_summary"></editor>
        </div>
      </div>
      <div class="col-sm-6">
        <div class="titleBody">
          <div class="titleAdd">
            <div class="titleAdd__plus" *ngFor="let desc of descs" (click)="append(resume, desc)">
              <div class="titleAdd__text"><span>Add</span></div>
              <div class="titleAdd__body" [innerHTML]="desc"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12 col-12">
        <div class="addSummary__buttons">
          <button class="btn btn-default" routerLink="/resume/edu">Skip</button>
          <button class="btn btn-primary" (click)="save()">Save &amp; Next</button>
        </div>
      </div>
      <!-- <div class="col-sm-6 col-8 text-left">
        <div class="addSummary__buttons">
          <button class="btn btn-default" routerLink="/resume/edu">Skip</button>
          <button class="btn btn-primary" (click)="save()">Save &amp; Next</button>
        </div>
      </div> -->
    </div>
  </div>
</div>
<app-footer></app-footer>
